export default function PhilosophySection() {
  return (
    <section className="w-full bg-background-50" aria-labelledby="philosophy-heading">
      <div className="flex flex-col lg:flex-row">
        {/* Left side - 60% width */}
        <div className="w-full lg:w-[60%] px-10 md:px-16 lg:px-20 py-16 md:py-20 lg:py-28">
          {/* Small label with bullet */}
          <div className="flex items-center gap-3 mb-16 md:mb-20">
            <span className="w-2 h-2 rounded-full bg-foreground-800 flex-shrink-0" aria-hidden="true"></span>
            <span className="text-xs font-medium uppercase tracking-[0.2em] text-foreground-500 font-label">Our Philosophy</span>
          </div>

          {/* Large quote */}
          <blockquote className="max-w-lg">
            <span className="font-heading text-6xl md:text-8xl text-foreground-300 leading-none select-none" aria-hidden="true">&ldquo;</span>
            <p className="font-heading text-3xl md:text-4xl lg:text-[3.25rem] leading-[1.25] text-foreground-900 font-medium mt-2">
              We believe great software emerges from disciplined engineering, thoughtful architecture, and an unwavering commitment to quality.
            </p>
          </blockquote>

          {/* Attribution */}
          <div className="mt-12 md:mt-16">
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-foreground-500 font-label">
              Engineering Principle
            </p>
          </div>
        </div>

        {/* Right side - 40% width - abstract wireframe */}
        <div className="w-full lg:w-[40%] bg-background-50 flex items-stretch min-h-[350px] lg:min-h-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20black%20and%20white%20geometric%20wireframe%20composition%20with%20clean%20circles%20rectangles%20and%20connecting%20lines%20in%20thin%20stroke%20weights%2C%20minimalist%20technical%20drawing%20style%2C%20system%20architecture%20pattern%2C%20pure%20white%20background%2C%20precise%20mathematical%20aesthetic%2C%20no%20text%2C%20fine%20line%20art%20illustration%20with%20nodes%20and%20geometric%20connections&width=720&height=900&seq=sivora-wireframe&orientation=portrait"
            alt="Abstract geometric wireframe composition evoking system architecture and engineering precision"
            title="Engineering Architecture Philosophy"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}